import parse, { domToReact, DOMNode, Element } from 'html-react-parser';
import React from 'react';

export const parseText = (text: string) => {
  return parse(text, {
    replace: domNode => {
      if ((domNode as Element).name === 'a') {
        return (
          <a
            href={(domNode as Element).attribs.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {domToReact(Array.from((domNode as Element).children) as DOMNode[])}
          </a>
        );
      }
      // Logic for headings
      if (/^h[1-6]$/.test((domNode as Element).name)) {
        const style = { marginBottom: '20px' }; // Adjust the value for headings as needed
        return React.createElement(
          (domNode as Element).name,
          { style },
          domToReact(Array.from((domNode as Element).children) as DOMNode[])
        );
      }
    },
  });
};
